import _Luminous2 from "./Luminous";
import _LuminousGallery2 from "./LuminousGallery";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Luminous", {
  enumerable: true,
  get: function get() {
    return _Luminous.default;
  }
});
Object.defineProperty(exports, "LuminousGallery", {
  enumerable: true,
  get: function get() {
    return _LuminousGallery.default;
  }
});

var _Luminous = _interopRequireDefault(_Luminous2);

var _LuminousGallery = _interopRequireDefault(_LuminousGallery2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} //# sourceMappingURL=lum.js.map


export default exports;
export const __esModule = exports.__esModule,
      Luminous = exports.Luminous,
      LuminousGallery = exports.LuminousGallery;